module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/coins_right-7355607d2c264ed4ded5c8d47c110c3c.png";